import { LogErrors } from './../LogErrors'

import { DoubleAttempt } from './Helpers/DoubleAttempt'


/**
 * Marca que el usuario ya ingresó al centro con el perfil indicado (primer ingreso).
 * Idempotente: si ya estaba marcado, el backend responde 200 sin escribir de nuevo.
 */
const UpdateCenterUserFirstTime = async (idCenter, idUserRol, token) => {
    try {
        const dataToSend = {
            IdCenter: idCenter,
            IdUserRol: idUserRol
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + '/api/V5/Users/UpdateCenterUserFirstTime'
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response?.message }
        }
    } catch (error) {
        await LogErrors('UpdateCenterUserFirstTime - Users DL', error)
        return { success: false, message: `No ha sido posible actualizar el estado de primer ingreso.` }
    }
}

export { UpdateCenterUserFirstTime };
